<template>
	<div id="buildingEnterForm" class="formPage">
		<formheader :title="title"></formheader>
		<div class="mainContent">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm formWrap">
				<el-form-item label="姓名" prop="appRealname">
					<el-input v-model="ruleForm.appRealname" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="appCellphone">
					<el-input type="text" v-model="ruleForm.appCellphone" placeholder="请输入手机号" @change="filterPhone"></el-input>
				</el-form-item>
				<el-form-item label="公司名称" prop="appCompanyName">
					<el-input v-model="ruleForm.appCompanyName" placeholder="请输入公司"></el-input>
				</el-form-item>
				<el-form-item label="您需要的金融服务" class="blockLabel" prop="jrfw_content" >
					<el-input type="textarea" :rows="4" v-model="ruleForm.jrfw_content" placeholder="在此输入您需要的金融服务"></el-input>
				</el-form-item>

				<!--<el-button @click="resetForm('ruleForm')">重置</el-button>-->

			</el-form>
            <div class="btnBox">
                <button id="submitBtn" class="btn-long btn-red" @click="submitForm('ruleForm')">提交</button>
                <a href="tel:0571-86221010">
                   <button  class="btn-long btn-red reverse">
                        <img src="../../images/newImages/but_ic_phone.png" alt="" class="btnIcon"> 0571-86221010 
                   </button> 
                </a>
                
            
            </div>
         <!--   
			<div class="center small red">
				<a href="tel:0571-86221010">客服电话：0571-86221010</a>
			</div>
			<div class="longBtnBox">
				<button type="primary" @click="submitForm('ruleForm')" class="btn-long btn-red">提交</button>
			</div> -->
		</div>

	</div>
</template>

<script>
	import formheader from '@/page/formPage/formHeader';
	import axios from 'axios';
	import { ajaxform, ajaxToken } from '@/assets/request.js'
	import { formRule,filterPhoneNum } from '@/assets/common.js'
	export default {
		data() {
			return {
				title: "金融支持",
				ruleForm: {
					appRealname: '',
					appCellphone: '',
					appCompanyName: '',
				},
				rules: formRule()

			}
		}, //data end
		components: {
			formheader
		},
		methods: {
				filterPhone(){
				this.ruleForm.appCellphone=filterPhoneNum(this.ruleForm.appCellphone)
			},
			submitForm(formName) {
				console.log(this.ruleForm.appCompanyName)
				console.log(this.ruleForm.appCompanyName.length)
				
				let _this = this
				let type = 3 //1为综合体线下实体空间入驻申请，2为相关政策了解申请，3为金融服务申请，4为产业配套服务申请，5为产业互联网服务申请，6为工厂培训申请
				this.$refs[formName].validate((valid) => {
					if(valid) {
						ajaxform(type, "/infoplatform/fashionapplication/applicationMessageEntry", _this.ruleForm).then((res) => {
							console.log("成功res")
							console.log(res)
						}, (res) => {
							console.log("失败res")
							console.log(res)
						})
						//						
					} else {
                        _this.$message({
                        	message:"表单填写不正确",
                        	duration: 1000,
                        });
						console.log('error submit!!');
						return false;
					}
				});
			},
		},
		mounted() {
console.log(formRule())
		}
	}
</script>

<style lang="less">
	// *{outline:1px solid blue;}
	.formPage{
        background: #fff;
	    .btnBox{ 
	        padding:0.6rem 0.32rem; 
	        button.btn-long{font-size: 0.36rem ;margin-bottom: 0.4rem;}
	        .btnIcon{
	            width: 0.48rem;height: 0.48rem; vertical-align: bottom;
	        }
	    }
	}
	.el-form-item{
	    // outline:1px solid blue;
	    background: #fff; padding:0 0.32rem; 
	    border-bottom: 1px solid #eee;
	}
	/*表单label比较长的部分样式*/
	
	.formWrap .blockLabel {
		.el-form-item__label {
			display: block;
			width: 100% !important;
			text-align: left !important;
			text-align-last: auto !important;
	        
		}
		.el-radio__label {
			font-size: 0.29rem; color:#111A34; font-weight: bold;
		}
		.el-form-item__content {
			margin-left: 0.1rem !important;
			;
		}
		.el-radio {
			display: block !important;
			line-height: 5;
	        border-bottom: 1px solid #eee; 
		}
		.el-radio+.el-radio {
			margin-left: 0 !important;
		}
	}
	
	.formWrap {
	    background: #fff; padding-top:0.22rem;
		// padding: 0.8rem 0.7rem 0.2rem;
		/*输入框*/
		.el-input__inner {
			// height: 0.75rem;
			// line-height: 0.75rem;
	        border:none;
	        padding-bottom: 0.22rem;
	        padding-left:0;
		}
		.el-textarea__inner {
			padding: 0px 10px;
		}
		/*标签*/
		.el-form-item__label {
			// font-weight: bold;
			text-align: left;
			// text-align-last: justify;
			/*padding-left:0.7rem;*/
		}
		.el-form-item {
			margin-bottom: 0.2rem;
		}
		.el-form-item__error {
			padding-top: 0;
		}
		.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
			margin-right: 0;
		}
	    textarea{border:0;}
	}
</style>


// WEBPACK FOOTER //
// src/page/formPage/finacyForm.vue